class Planet {
    constructor(
      name,
      climate,
      diameter,
      gravity,
      orbitalPeriod,
      population,
      rotationPeriod,
      surfaceWater,
      terrain,
      created,
      edited,
      films,
      residents,
      url
    ) {
      this.name = name;
      this.climate = climate;
      this.diameter = diameter;
      this.gravity = gravity;
      this.orbitalPeriod = orbitalPeriod;
      this.population = population;
      this.rotationPeriod = rotationPeriod;
      this.surfaceWater = surfaceWater;
      this.terrain = terrain;
      this.created = created;
      this.edited = edited;
      this.films = films;
      this.residents = residents;
      this.url = url;
    }
  }
  
  export default Planet;
  